import React, { useState } from 'react';
import { getFavProperties } from '../api';
import List from '../components/core/List';
import Wrapper from '../components/core/Wrapper';
import Pagination from '../components/Pagination/Pagination';
import { Property } from '../components/Property/Property';

export default function Favorites() {
  const [triggerReload, setTriggerReload] = useState(false);

  const handleFavoriteClick = () => {
    setTriggerReload(!triggerReload);
  };

  return (
    <Pagination
      triggerReload={triggerReload}
      apiFn={getFavProperties}
      render={(items, isLoading, error, paginationEl) => (
        <Wrapper subHeader={{ title: 'MIS FAVORITOS' }}>
          {isLoading ? (
            <p>Cargando...</p>
          ) : !!error ? (
            <p>Error cargando favoritos</p>
          ) : items?.length === 0 ? (
            <p>No tienes favoritos</p>
          ) : (
            <List>
              {items?.map(
                ({ id, property }: any) =>
                  property && (
                    <Property
                      key={id}
                      property={property}
                      onFavorite={handleFavoriteClick}
                    />
                  )
              )}
            </List>
          )}

          {paginationEl}
        </Wrapper>
      )}
    />
  );
}
